(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6567],{

/***/ 68843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_RightOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/RightOutlined.js
// This icon file is generated automatically.
var RightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, "name": "right", "theme": "outlined" };
/* harmony default export */ var asn_RightOutlined = (RightOutlined);

// EXTERNAL MODULE: ./node_modules/antd/node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(93771);
;// CONCATENATED MODULE: ./node_modules/antd/node_modules/@ant-design/icons/es/icons/RightOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY



var RightOutlined_RightOutlined = function RightOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    ref: ref,
    icon: asn_RightOutlined
  }));
};
RightOutlined_RightOutlined.displayName = 'RightOutlined';
/* harmony default export */ var icons_RightOutlined = (/*#__PURE__*/react.forwardRef(RightOutlined_RightOutlined));

/***/ }),

/***/ 71829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(50880);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-markdown/src/react-markdown.js
var react_markdown = __webpack_require__(38456);
var react_markdown_default = /*#__PURE__*/__webpack_require__.n(react_markdown);
// EXTERNAL MODULE: ./node_modules/antd/es/typography/index.js + 20 modules
var typography = __webpack_require__(51945);
// EXTERNAL MODULE: ./node_modules/antd/es/tabs/index.js + 25 modules
var tabs = __webpack_require__(86873);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/antd/es/table/index.js + 136 modules
var table = __webpack_require__(97565);
// EXTERNAL MODULE: ./node_modules/antd/es/divider/index.js + 1 modules
var divider = __webpack_require__(96074);
// EXTERNAL MODULE: ./components/comments/Comments.tsx + 1 modules
var Comments = __webpack_require__(35428);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/ipos/FinancialsFilings.tsx




var Title = typography/* default.Title */.Z.Title;

var FinancialsFilings = function FinancialsFilings(_ref) {
  var propData = _ref.propData;
  var financialsData = [{
    attribute: 'Revenue',
    value: propData === null || propData === void 0 ? void 0 : propData.revenue
  }, {
    attribute: 'Net Income',
    value: propData === null || propData === void 0 ? void 0 : propData.net_income
  }, {
    attribute: 'Total Assets',
    value: propData === null || propData === void 0 ? void 0 : propData.total_assets
  }, {
    attribute: 'Total Liabilities',
    value: propData === null || propData === void 0 ? void 0 : propData.total_liabilities
  }, {
    attribute: "Stockholder's Equity",
    value: propData === null || propData === void 0 ? void 0 : propData.stock_holders_equity
  }];
  var financialsColumns = [{
    title: 'Attribute',
    dataIndex: 'attribute',
    key: 'attribute',
    render: function render(text) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("b", {
        children: text
      });
    }
  }, {
    title: 'Value',
    dataIndex: 'value',
    key: 'value',
    render: function render(text) {
      return text;
    }
  }];
  var filingDateReceived = propData === null || propData === void 0 ? void 0 : propData.date_received.split(',');
  var filingLink = propData === null || propData === void 0 ? void 0 : propData.filing_link.split(',');
  var formType = propData === null || propData === void 0 ? void 0 : propData.form_type.split(',');
  var filingsColumns = [{
    title: 'Company Name',
    dataIndex: 'company_name',
    key: 'company_name'
  }, {
    title: 'Date Received',
    dataIndex: 'date_received',
    key: 'date_received'
  }, {
    title: 'Form Type',
    dataIndex: 'form_type',
    key: 'form_type'
  }, {
    title: 'View',
    dataIndex: 'view',
    key: 'view',
    render: function render(text) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: text,
        target: "_blank",
        rel: "noopener noreferrer",
        children: "Link"
      });
    }
  }];
  var filingsDataSource = filingDateReceived.filter(function (item) {
    return item.length !== 0;
  }).map(function (item, i) {
    return {
      key: i,
      company_name: propData === null || propData === void 0 ? void 0 : propData.name,
      date_received: item,
      form_type: formType[i],
      view: filingLink[i]
    };
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
      className: "title-wrapper",
      children: "Company Financials"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(table/* default */.Z, {
      columns: financialsColumns,
      dataSource: financialsData,
      bordered: true,
      showHeader: false,
      pagination: false
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
      className: "title-wrapper",
      children: "Company Filings"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(table/* default */.Z, {
      bordered: true,
      dataSource: filingsDataSource,
      columns: filingsColumns,
      pagination: false
    })]
  });
};

/* harmony default export */ var ipos_FinancialsFilings = (FinancialsFilings);
;// CONCATENATED MODULE: ./components/ipos/index.tsx







var ipos_Title = typography/* default.Title */.Z.Title;

var IpoContent = function IpoContent(_ref) {
  var ipoData = _ref.ipoData;
  var attributes = ipoData.attributes;
  var related = 'api::ipo.ipo';

  var _useState = (0,react.useState)(''),
      href = _useState[0],
      setHref = _useState[1];

  var _useState2 = (0,react.useState)(true),
      toggleTab = _useState2[0],
      setToggleTab = _useState2[1];

  var TabPane = tabs/* default.TabPane */.Z.TabPane;
  var financialDataObj = {
    name: ipoData.attributes.name,
    revenue: ipoData.attributes.revenue,
    net_income: ipoData.attributes.net_income,
    total_assets: ipoData.attributes.total_assets,
    total_liabilities: ipoData.attributes.total_liabilities,
    stock_holders_equity: ipoData.attributes.stock_holders_equity,
    form_type: ipoData.attributes.form_type,
    date_received: ipoData.attributes.date_received,
    filing_link: ipoData.attributes.filing_link
  };
  (0,react.useEffect)(function () {
    if (!['--', ' -- '].includes(attributes.website)) {
      var str = attributes.website;
      var div = document.createElement('div');
      div.innerHTML = str;
      var a = div.querySelector('a');
      setHref(a.getAttribute('href'));
    }
  }, []);
  var columns = [{
    title: 'Attribute',
    dataIndex: 'attribute',
    key: 'attribute',
    render: function render(text) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("b", {
        children: text
      });
    }
  }, {
    title: 'Value',
    dataIndex: 'value',
    key: 'value',
    render: function render(text) {
      if (attributes.website && text === attributes.website) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: href,
          children: href
        });
      }

      return text;
    }
  }];
  var dataSource = [{
    attribute: 'Proposed Symbol',
    value: "".concat(attributes.symbol)
  }, {
    attribute: 'Company Name',
    value: "".concat(attributes.name)
  }, {
    attribute: 'Exchange',
    value: "".concat(attributes.exchange)
  }, {
    attribute: 'Share Price',
    value: "".concat(attributes.share_price)
  }, {
    attribute: 'Employees',
    value: "".concat(attributes.employees)
  }, {
    attribute: 'Status',
    value: "".concat(attributes.status)
  }, {
    attribute: 'Shares Offered',
    value: "".concat(attributes.shares_offered)
  }, {
    attribute: 'Offer amount',
    value: "".concat(attributes.offer_amount)
  }, {
    attribute: 'Shares Over Alloted',
    value: "".concat(attributes.shares_over_alloted)
  }, {
    attribute: 'Company Address',
    value: "".concat(attributes.address)
  }, {
    attribute: 'Company Phone',
    value: "".concat(attributes.phone)
  }, {
    attribute: 'Company Website',
    value: "".concat(attributes.website === '--' || attributes.website === ' -- ' ? 'N/A' : attributes.website)
  }, {
    attribute: 'CEO',
    value: "".concat(attributes.ceo)
  }, {
    attribute: 'State of Inc',
    value: "".concat(attributes.state_inc)
  }, {
    attribute: 'Fiscal Year End',
    value: "".concat(attributes.fiscal_year_end)
  }, {
    attribute: 'Total Offering Expense',
    value: "".concat(attributes.offering_expense)
  }, {
    attribute: 'Shareholder Shares Offered',
    value: "".concat(attributes.shares_offered)
  }, {
    attribute: 'Shares Outstanding',
    value: "".concat(attributes.shares_outstanding)
  }, {
    attribute: 'Lockup Period (days)',
    value: "".concat(attributes.lockup_days)
  }, {
    attribute: 'Lockup Expiration',
    value: "".concat(attributes.lockup_expiration)
  }, {
    attribute: 'Quiet Period Expiration',
    value: "".concat(attributes.quiet_period_expiration)
  }, {
    attribute: 'CIK',
    value: "".concat(attributes.cik)
  }, {
    attribute: 'DealId',
    value: "".concat(attributes.deal_id)
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
    className: "page-wrapper page",
    gutter: [16, 16],
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
      xs: 24,
      md: 16,
      lg: 18,
      span: 12,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ipos_Title, {
        className: "title-wrapper",
        children: attributes.name
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(tabs/* default */.Z, {
        defaultActiveKey: "1",
        onTabClick: function onTabClick(e) {
          setToggleTab(e === '1');
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TabPane, {
          tab: "Overview",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ipos_Title, {
            className: "title-wrapper",
            children: "Company Overview"
          }), toggleTab && /*#__PURE__*/(0,jsx_runtime.jsx)(table/* default */.Z, {
            columns: columns,
            dataSource: dataSource,
            bordered: true,
            showHeader: false,
            pagination: false
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)(ipos_Title, {
            className: "title-wrapper",
            children: "Company Description"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)((react_markdown_default()), {
            children: attributes.description
          })]
        }, "1"), /*#__PURE__*/(0,jsx_runtime.jsx)(TabPane, {
          tab: "Financials & Filings",
          children: !toggleTab && /*#__PURE__*/(0,jsx_runtime.jsx)(ipos_FinancialsFilings, {
            propData: financialDataObj
          })
        }, "2")]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(divider/* default */.Z, {
        style: {
          color: '#1890ff'
        },
        children: "Still got Doubts?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Comments/* default */.Z, {
        articleData: ipoData,
        related: related
      })]
    })
  });
};

/* harmony default export */ var ipos = (IpoContent);
// EXTERNAL MODULE: ./graphql/generated/types.tsx
var types = __webpack_require__(13492);
// EXTERNAL MODULE: ./layouts/application.tsx + 4 modules
var application = __webpack_require__(8182);
// EXTERNAL MODULE: ./node_modules/nookies/dist/index.js
var dist = __webpack_require__(62286);
// EXTERNAL MODULE: ./shared/util.tsx + 6 modules
var util = __webpack_require__(77713);
;// CONCATENATED MODULE: ./pages/ipos/[slug].tsx











var Ipo = function Ipo(props) {
  var apolloClient = (0,useApolloClient/* useApolloClient */.x)();
  var propsData = props.data;

  var _useState = (0,react.useState)(propsData),
      data = _useState[0],
      setData = _useState[1];

  var allBrokers = data.all_brokers,
      ipo = data.ipo,
      navCalculators = data.all_calculators,
      allPages = data.all_pages;
  var ipoData = ipo.data[0];
  (0,react.useEffect)(function () {
    apolloClient.query({
      query: types/* IpoCommentsDocument */.eX,
      variables: {
        relation: "api::ipo.ipo:".concat(data.ipo.data[0].id),
        sort: 'createdAt:desc'
      }
    }).then(function (res) {
      if ((0,util/* countComments */.Mw)(res.data.plugin_comments) !== (0,util/* countComments */.Mw)(data.ipo.data[0].attributes.plugin_comments)) {
        data.ipo.data[0].attributes.plugin_comments = res.data.plugin_comments;
        setData(data);
      }
    }); // handlePageLoad(apolloClient)

    var cookies = (0,dist.parseCookies)();

    if (!cookies.country) {
      (0,dist.setCookie)(null, 'country', 'us', {
        path: ['/'] // cookie path

      });
    }
  }, []);

  var description = function description() {
    return "A Personal Finance FAQ portal for India, Canada & USA investors. Financial education hub sharing broker\nreviews, stock market queries, trading & investment software and apps.";
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(application/* default */.Z, {
    allBrokers: allBrokers.data,
    navCalculators: navCalculators.data,
    allPages: allPages.data,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "IPOs - Fintrakk"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: description()
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ipos, {
      ipoData: ipoData
    })]
  });
};

var __N_SSP = true;
/* harmony default export */ var _slug_ = (Ipo);

/***/ }),

/***/ 12982:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ipos/[slug]",
      function () {
        return __webpack_require__(71829);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 50029:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5407,2453,3229,7752,2913,1945,2682,2769,7527,6873,6568,2841,5239,7565,2139,8182,3492,5428,9774,2888,179], function() { return __webpack_exec__(12982); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);